import { ICollectionPageHeaderProps } from ".";

export const CollectionPageHeader = (props: ICollectionPageHeaderProps) => {
  const { merchstore } = props;

  return (
    <div className="flex-col items-center justify-center align-center">
      <div className="flex items-center justify-center">
        <img src={merchstore.bannerImage} className="w-full "/>
      </div>
      <div className="flex items-center text-center justify-center my-20 xl:my-60">
        <h1 className="w-10/12 lg:w-6/12 font-bold text-xl xl:text-3xl ">{merchstore.storeMessage}</h1>
      </div>
    </div>
  )
}